import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRename(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 3C3.89543 3 3 3.89543 3 5V11C3 11.5523 3.44772 12 4 12C4.55228 12 5 11.5523 5 11V5H19V19H13C12.4477 19 12 19.4477 12 20C12 20.5523 12.4477 21 13 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3674 7.55286C13.6303 6.81571 12.4372 6.81571 11.7001 7.55286L3.42621 15.8267C3.15194 16.101 3 16.4611 3 16.8538V19.5556C3 20.3568 3.64324 21 4.44438 21H7.14623C7.49942 21 7.88696 20.868 8.17722 20.561L16.4471 12.2999C17.1843 11.5628 17.1843 10.3697 16.4471 9.63257L14.3674 7.55286ZM13 9L15 11L7 19H5V17L13 9Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
